// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2EWMU","boxTitle":"Qualiphy_boxTitle__1uCp3","box":"Qualiphy_box__1_jKa","toggleWrap":"Qualiphy_toggleWrap__NsHE8"};